const whitelist = ['overview', 'installation'];

export function isPostIdWhitelisted(postId: string): boolean {
  return whitelist.includes(postId);
}
